export default "__VITE_ASSET__Dgz9RGjy__"